package net.bothosting.docs.pages.hosting_in_bot_hosting_net

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initConnect_to_your_servers_files_with_sftpPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("hosting_in_bot_hosting_net/connect_to_your_servers_files_with_sftp.md", FrontMatterElement.Builder { addScalar("description", "SFTP is a popular protocol for connecting to a server's files and uploading/downloading files. It is a great way to manage files and upload your files from your PC."); addScalar("icon", "arrow-up-arrow-down"); }))
}

@Page("/hosting_in_bot_hosting_net/connect-to-your-servers-files-with-sftp")
@Layout(".components.layouts.DocsLayout")
@Composable
fun Connect_to_your_servers_files_with_sftpPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("connect-to-your-server-s-files-with-sftp") }) {
        org.jetbrains.compose.web.dom.Text("Connect to your server's files with SFTP")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You can use an SFTP client to connect to your server on bot-hosting.net and manage its files.")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("downloading-an-sftp-client") }) {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Downloading an SFTP client")
        }
        org.jetbrains.compose.web.dom.Text(" ")
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("a", attrs = {attr("href", "#s5w8fietfez");attr("id", "s5w8fietfez")}) {
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The first thing you need to do is download an SFTP client, which is used to connect to the SFTP server and manage files. This guide uses screenshots from WinSCP, but you can also use FileZilla. Download links:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://winscp.net/eng/download.php") {
                org.jetbrains.compose.web.dom.Text("WinSCP")
            }
            org.jetbrains.compose.web.dom.Text(" (Windows only)")
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://filezilla-project.org/download.php?type=client") {
                org.jetbrains.compose.web.dom.Text("FileZilla")
            }
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Once downloaded, install the client you have chosen.")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("getting-your-sftp-connection-details") }) {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Getting your SFTP connection details")
        }
        org.jetbrains.compose.web.dom.Text(" ")
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("a", attrs = {attr("href", "#bcieat1xcmp");attr("id", "bcieat1xcmp")}) {
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("To connect to the SFTP server, you need your connection details. In the control panel, go to the Settings tab of your server.")
    }
    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figure") {
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("img", attrs = {attr("src", "../.gitbook/assets/image (19).png");attr("alt", "")})
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figcaption")
    }

    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("If you have an SFTP client installed, you can click ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("Launch SFTP")
        }
        org.jetbrains.compose.web.dom.Text(" and it will open your SFTP client with the details entered.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("If your SFTP client does not launch for any reason, you can always start it yourself and copy and paste the connection details. Remember, the number after the ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text(":")
        }
        org.jetbrains.compose.web.dom.Text(" at the end is the port, and the part before it is the host. In this example, ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("example.bot-hosting.net")
        }
        org.jetbrains.compose.web.dom.Text(" is the host and ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("2022")
        }
        org.jetbrains.compose.web.dom.Text(" is the port.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You will then need your SFTP password, which can be generated on the ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://bot-hosting.net/panel/settings") {
            org.jetbrains.compose.web.dom.Text("settings page")
        }
        org.jetbrains.compose.web.dom.Text(" of the client panel.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Once all the details have been entered, you can connect. You may be prompted to accept the server's keys, with a warning that you have not connected to this server before. If that happens, click Yes. The warning may look as follows:")
    }
    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figure") {
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("img", attrs = {attr("src", "../.gitbook/assets/image (20).png");attr("alt", "")})
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figcaption")
    }

    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You should then be connected and able to manage your files. You can copy files from your PC and use the upload and download functions.")
    }
}
